"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('markFavoritePersonaNodeAsAdded')(legacy_1.select({
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
})(function markFavoritePersonaNodeAsAdded(favoriteId, state) {
    var personaNode = state.favoritesPersonaNodes.get(favoriteId);
    if (personaNode) {
        personaNode.isJustAdded = false;
    }
}));
//# sourceMappingURL=markFavoritePersonaNodeAsAdded.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/markFavoritePersonaNodeAsAdded.js
// module id = 4646
// module chunks = 14